<div class="procedure-selection" data-cy="procedure-selection-dialog-header">
  Select procedure / case for appointment
</div>


<mat-tab-group (selectedTabChange)="tabChanged($event)" data-cy="procedure-selection-tabs">
  <mat-tab label="New Case" data-cy="procedure-selection-new-case-tab">

    <span style="font-size: medium; font-weight: bold; margin-left: 8px;" data-cy="procedure-selection-new-case-title">Select a procedure for the new appointment</span>

    <dx-list
      #procList
      [dataSource]="data.procedures"
      [selectionMode]="'single'"
      [pageLoadMode]="'scroll'"
      [height]="700"
      (onSelectionChanged)="onProcSelectionChanged($event)"
      data-cy="procedure-selection-new-procedures-list"
    >

        <div *dxTemplate="let data of 'item'" data-cy="procedure-selection-procedure-item">
          <div data-cy="procedure-selection-procedure-name">{{ data.ProcedureName }}</div>
        </div>




    </dx-list>




  </mat-tab>
  <mat-tab label="Existing Case" data-cy="procedure-selection-existing-case-tab">

    <span style="font-size: medium; font-weight: bold; margin-left: 8px;" data-cy="procedure-selection-existing-case-title">Step 1 - Select a Case</span>



    <dx-list
      #caseList
      [dataSource]="patientCases"
      [height]="400"
      [selectionMode]="'single'"
      [pageLoadMode]="'scroll'"
      (onSelectionChanged)="onCaseSelectionChanged($event)"
      data-cy="procedure-selection-existing-cases-list"
    >
      <div *dxTemplate="let data of 'item'"  class="caserow" data-cy="procedure-selection-case-item">
        <div class="casecolumn-descr" data-cy="procedure-selection-case-description">{{ data.Description == null ||  data.Description =='' ? '-' : data.Description }}</div>
        <div class="casecolumn-tooth" data-cy="procedure-selection-case-tooth">{{ data.Teeth=='' ? '-' : data.Teeth }}</div>
        <div class="casecolumn-status" data-cy="procedure-selection-case-status">{{ data.CaseStatus  }}</div>
        <div class="casecolumn-status-date" data-cy="procedure-selection-case-date">{{ data.StatusOn | date: 'shortDate' }} {{ data.StatusOn | date: 'shortTime' }}</div>

      </div>

    </dx-list><br/>


    <span style=" font-size: medium; font-weight: bold; margin-left: 8px; margin-top: 10px; " data-cy="procedure-selection-case-procedures-title">Step 2 - Select a Procedure from the case</span>




    <dx-list
      #caseProcList
      [dataSource]="patientCaseProcedures"
      [height]="250"
      [selectionMode]="'single'"
      (onSelectionChanged)="onCaseProcSelectionChanged($event)"
      data-cy="procedure-selection-case-procedures-list"
    >
      <div *dxTemplate="let data of 'item'" data-cy="procedure-selection-case-procedure-item">
        <div data-cy="procedure-selection-case-procedure-name">{{ data.ProcedureName }}</div>
      </div>

    </dx-list>

    <div data-cy="procedure-selection-followup-container">
    Reason for followup

    <app-tdo-enum-select style="z-index: 1000;" [validValueItemId]="selectEnumCaseFollowupReasonID" name="enumCaseFollowupReason"
                         (enumSelected)="onDropdownItemSelected($event)" data-cy="procedure-selection-followup-reason"></app-tdo-enum-select>

    </div>
  </mat-tab>
</mat-tab-group>





<div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="procedure-selection-footer">
  <div style="flex: 1; margin-right: 6px;"></div>
  <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="procedure-selection-cancel-button">Cancel</button>
  <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="procedure-selection-ok-button">Ok</button>
</div>
